// Carry Roll React root — AppLockProvider → AppGate → App.

import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { AppLockProvider } from './components/AppLock';
import { AppGate } from './AppGate';
import { installNavHashSync } from './lib/navHashSync';
import 'calc-controls/styles.css';
import 'calc-nav/styles.css';
import 'calc-sidebar/styles.css';
import './styles/index.css';

// calc-sidebar's SidebarNav selects items via history.pushState, which fires no
// native event. Patch it once (idempotent) so the rest of the shell can observe
// sidebar-driven navigation and stay in sync (e.g. Header active state).
installNavHashSync();

registerSW({ onNeedRefresh() {}, onOfflineReady() {} });

// Hidden delight — a wordmark in the developer console for the curious who
// pop open devtools. On-brand (fairway-green instrument chrome), no UI cost.
if (typeof console !== 'undefined' && console.info) {
  console.info(
    '%cCarry Roll %c— golf ball-flight model',
    `color: var(--color-accent, #6cc585); font-weight: 700; font-size: 14px;`,
    `color: #8e9c82; font-size: 12px;`,
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppLockProvider>
      <AppGate />
    </AppLockProvider>
  </React.StrictMode>,
);
